export type MosaicTrafficLightSwitch = "DoNotCalculate" | "Calculate";

/**
 * Type guard for `MosaicTrafficLightSwitch` values.
 *
 * @param obj - The value to test.
 * @returns True when `obj` is a `MosaicTrafficLightSwitch`, otherwise false.
 */
export const isMosaicTrafficLightSwitch = (obj: unknown): obj is MosaicTrafficLightSwitch => {
  return typeof obj === "string" && ["DoNotCalculate", "Calculate"].includes(obj);
};
